import {
  BOOTSTRAP_FEATURE_KEY,
  bootstrapReducer,
  CASHIER_CONFIGURATION_FEATURE_KEY,
  cashierConfigurationReducer,
  CONFIRMATION_FORM_FEATURE_KEY,
  confirmationFormReducer,
  confirmationTimerEpic,
  CUSTOMER_INFORMATION_KEY,
  customerInformationReducer,
  fetchCertainPaymentMethodEpic,
  fetchDirecta24OptionsEpic,
  fetchMifinityOptionsEpic,
  fetchPaymentCurrentStateEpic,
  fetchPaymentInfoEpic,
  FILE_UPLOADING_FEATURE_KEY,
  fileUploadingReducer,
  LEADER_IFRAME_BRIDGE_KEY,
  PAYMENT_CONFIRMATION_FEATURE_KEY,
  PAYMENT_FORM_FEATURE_KEY,
  PAYMENT_METHOD_FEATURE_KEY,
  PAYMENT_PROCESSING_FEATURE_KEY,
  PAYMENT_REGISTRATION_FEATURE_KEY,
  PAYMENT_SNAPSHOT_FEATURE_KEY,
  paymentConfirmationEpic,
  paymentConfirmationReducer,
  paymentFormReducer,
  paymentMethodReducer,
  paymentProcessingEpic,
  paymentProcessingReducer,
  paymentRegistrationEpic,
  paymentRegistrationReducer,
  paymentSnapshotReducer,
  preprocessorReducer,
  refetchCertainPaymentMethodEpic,
  uploadFileEpic,
} from '@cashier/cashier-data-access';
import { createFeature } from '@cashier/cashier-shared';

import {
  activeScreenMiddleware,
  bonusCodeMiddleware,
  cashierHostedFieldBridgeMiddleware,
  commonMiddleware,
  communicationTasksMiddleware,
  confirmationFormMiddleware,
  confirmationTimeoutMiddleware,
  parentNotificationMiddleware,
  paymentConfirmationMiddleware,
  paymentInfoMiddleware,
  paymentMethodMiddleware,
  paymentProcessingMiddleware,
  platformProcessingInitiatorMiddleware,
} from './lib/middlewares';
import { ConfirmationForm as ConfirmationFormV2 } from './lib/modules/confirmationForm/v2';
import { PaymentMethodLogo as PaymentMethodLogoV2 } from './lib/modules/paymentMethodLogo/v2';
import { PaymentMethodLogo as PaymentMethodLogoV3 } from './lib/modules/paymentMethodLogo/v3';
import { TaxInformation } from './lib/modules/tax/taxInformation';

export const CommonFeature = createFeature({
  component: {
    ConfirmationFormV2,

    PaymentMethodLogoV2,
    PaymentMethodLogoV3,
    TaxInformation,
  },

  hook: {},

  store: {
    reducerMap: {
      [PAYMENT_SNAPSHOT_FEATURE_KEY]: paymentSnapshotReducer,
      [BOOTSTRAP_FEATURE_KEY]: bootstrapReducer,
      [CONFIRMATION_FORM_FEATURE_KEY]: confirmationFormReducer,
      [PAYMENT_FORM_FEATURE_KEY]: paymentFormReducer,
      [CASHIER_CONFIGURATION_FEATURE_KEY]: cashierConfigurationReducer,
      [PAYMENT_METHOD_FEATURE_KEY]: paymentMethodReducer,
      [PAYMENT_CONFIRMATION_FEATURE_KEY]: paymentConfirmationReducer,
      [PAYMENT_PROCESSING_FEATURE_KEY]: paymentProcessingReducer,
      [PAYMENT_REGISTRATION_FEATURE_KEY]: paymentRegistrationReducer,
      [CUSTOMER_INFORMATION_KEY]: customerInformationReducer,
      [FILE_UPLOADING_FEATURE_KEY]: fileUploadingReducer,
      [LEADER_IFRAME_BRIDGE_KEY]: preprocessorReducer,
    },

    middlewares: [
      commonMiddleware,
      communicationTasksMiddleware,
      paymentConfirmationMiddleware,
      confirmationTimeoutMiddleware,
      confirmationFormMiddleware,
      paymentMethodMiddleware,
      paymentInfoMiddleware,
      paymentProcessingMiddleware,
      platformProcessingInitiatorMiddleware,
      activeScreenMiddleware,
      parentNotificationMiddleware,
      bonusCodeMiddleware,
      cashierHostedFieldBridgeMiddleware,
    ],

    epics: [
      paymentConfirmationEpic,
      confirmationTimerEpic,
      paymentProcessingEpic,
      paymentRegistrationEpic,
      fetchPaymentInfoEpic,
      fetchDirecta24OptionsEpic,
      fetchCertainPaymentMethodEpic,
      fetchPaymentCurrentStateEpic,
      fetchMifinityOptionsEpic,
      refetchCertainPaymentMethodEpic,
      uploadFileEpic,
    ],
  },
});
